import MontanaPriceProjectionInterface from "@app/Interface/MontanaPriceProjectionInterface";
import axios from "@app/Security/AxiosAuthentication";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class MontanaPriceProjectionHelper {

    /**
     * Gets montana price projections
     * 
     * @param controller AbortController - Handles when component is unmounted
     * @param fpuId      Currently selected FPU
     * @param pageId     Page ID is used to determine permission access
     * @returns 
     */
    static getPriceProjections = async ( controller: AbortController, fpuId: number, pageId: number): Promise<MontanaPriceProjectionInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.MONTANA_PRICE_PROJECTION + `?page=1&fpu_id=${fpuId}&page_id=${pageId}`;

        const url = baseUrl + endPoint;

        return await axios.get(url, {
            withCredentials: true,
            signal: controller.signal
        })
            .then(response => {

                const components: MontanaPriceProjectionInterface[] = response.data["hydra:member"];

                return components;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "MT getPriceProjections()");

                // return an empty set of navItems
                const emptyItems: Array<MontanaPriceProjectionInterface> = [];

                return emptyItems;

            });

    }

    /**
     * Filters the rows down to the limit, starting on the month modifier
     * If monthModifier = -1, start with previous month
     * limit = 5, get 5 records starting with the monthModifier
     * 
     * @param rows          original rows
     * @param limit         number of records to return
     * @param monthModifier modifier todays month. Determines which record to start with
     * @returns 
     */
     static getRowsForDashboard = (rows: MontanaPriceProjectionInterface[], limit: number, monthModifier: number): MontanaPriceProjectionInterface[] => {

        const filteredRows: MontanaPriceProjectionInterface[] = [];

        let foundCount = 0;

        const currentDate = new Date();

        // NOTE: currentDate.getMonth() is the index not the actual month 
        const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + monthModifier, 1);
       
        rows.forEach(row => {

            // NOTE: Date(Year, month index!!!, day); 
            const rowDate = new Date(row.PriceYear, row.PriceMonth - 1, 1);

            if (foundCount <= limit && startDate <= rowDate) {
                
                foundCount++;

                row.MonthYearDisplay = MontanaPriceProjectionHelper.getMonthYearDisplay(row);

                filteredRows.push(row);
            }

        });

        return filteredRows;

    }

    /**
     * gets the display for month year as Jan, 2021
     * 
     * @param data 
     * @returns 
     */
     static getMonthYearDisplay = (data: MontanaPriceProjectionInterface): string => {

        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];

        const displayMonth = months[data.PriceMonth - 1];

        const displayValue = `${displayMonth}, ${data.PriceYear}`;

        return displayValue;
    }

}